/**
 * This class handle generic tag model
 */
export abstract class GenericTag {
  protected _uid: string = "";
  protected _expirationDate: string = "";
  protected _cardNumber: number = 0;
  protected _plantCode: number = 0;

  //Getter UID
  public get UID(): string {
    return this._uid;
  }

  //Getter Expiration Date
  public get ExpirationDate(): string {
    return this._expirationDate;
  }

  //Getter Card number
  public get CardNumber(): number {
    return this._cardNumber;
  }

  //Getter PlantCode
  public get PlantCode(): number {
    return this._plantCode;
  }

  /*Setter Card number
   */
  public set CardNumber(cardN: number) {
    this._cardNumber = cardN;
  }

  /*Setter Card number
   */
  public set PlantCode(plant: number) {
    this._plantCode = plant;
  }

  constructor() {}

  /**
   * Calculate XOR of the block
   *
   * @param block         block to write
   * @returns {string}    XOR of first 13 chars
   */
  protected calculateChecksum(block: string): string {
    let checksum: number = 0;
    let i: number;
    let destra: number = 0;
    let xORFin: string = "";
    let stringaCHK: string = "";

    for (i = 0; i <= 13; i++) {
      if (i === 0) {
        checksum = 0;
      } else {
        destra = parseInt(block.substring(i * 2, i * 2 + 2), 16);
        checksum = checksum ^ destra; // XOR; true if bit are not equal
      }
    }
    stringaCHK = (
      "0000" + parseInt(checksum.toString(2), 10).toString(10)
    ).slice(-8);

    //Do NOT operator
    for (i = 0; i < 8; i++) {
      if (stringaCHK[i] === "0") {
        xORFin += "1";
      }
      if (stringaCHK[i] === "1") {
        xORFin += "0";
      }
    }

    return parseInt(xORFin, 2).toString(16);
  }
}
